import React from "react";
import { useRouter } from "next/router";

export const Header: React.FC<{}> = () => {
  const history = useRouter();
  return (
    <div className="relative bg-white">
      <div className="max-w-7xl">
        <div className="flex justify-between items-center shadow-md py-3 md:justify-start md:space-x-10">
          <div className="flex justify-start lg:w-0 lg:flex-1 ">
            <p
              onClick={() => history.push("/")}
              className="text-black t ml-6 mt-2 hover:cursor-pointer hover:text-slate-800"
            >
              {"o<>o"}
            </p>
          </div>
          <div className=" flex items-center justify-end mr-4">
            <button
              onClick={() => history.push("/login")}
              className="ml-8 whitespace-nowrap inline-flex items-center justify-center px-4 py-2 mr-4 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-black hover:bg-slate-700"
            >
              {" "}
              Sign in{" "}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
